import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import UserPage from 'flarum/forum/components/UserPage';
import Post from 'flarum/forum/components/Post';
import FlagList from 'ext:flarum/flags/forum/components/FlagList';
import { t } from './t';
export { default as extend } from './extend';
const isStaff = () => !!app.session.user && !!app.forum.attribute('canViewFlags');
app.initializers.add('ernestdefoe-docket', () => {
  extend(IndexSidebar.prototype, 'navItems', items => {
    if (!isStaff()) return;
    items.add('docket', m(LinkButton, {
      href: app.route('docket'),
      icon: "fas fa-clipboard-list"
    }, t('nav.report_centre')), 60);
  });
  extend(SessionDropdown.prototype, 'items', items => {
    if (!app.session.user) return;
    items.add('docket', m(LinkButton, {
      href: app.route('docket.mine'),
      icon: "fas fa-flag"
    }, t('nav.my_reports')), 55);
  });

  // A member's report history, for staff, on their profile.
  extend(UserPage.prototype, 'navItems', function (items) {
    if (!isStaff() || !this.user) return;
    const href = app.route('user.docket', {
      username: this.user.slug()
    });
    items.add('docket',
    // Active on both tabs: about their posts, and made by them.
    m(LinkButton, {
      href: href,
      active: m.route.get().split('?')[0].startsWith(href),
      icon: "fas fa-clipboard-list"
    }, t('nav.user_reports')), 5);
  });

  // From the flags dropdown and a flagged post's bar to the report centre.
  extend(FlagList.prototype, 'controlItems', items => {
    items.add('docket', m(LinkButton, {
      className: "Button Button--link",
      icon: "fas fa-clipboard-list",
      href: app.route('docket'),
      "aria-label": t('nav.report_centre')
    }, t('nav.report_centre')));
  });
  extend(Post.prototype, 'flagActionItems', function (items) {
    const post = this.attrs.post;
    items.add('docket', m(Button, {
      className: "Button",
      icon: "fas fa-clipboard-list",
      onclick: () => m.route.set(app.route('docket', {
        post: post.id()
      }))
    }, t('post.open_report')), -50);
  });

  // 🚨 By module name: NotificationGrid is in a lazy chunk in Flarum 2, so a
  // static import of it is undefined when initializers run.
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', items => {
    if (isStaff()) {
      items.add('docketAssigned', {
        name: 'docketAssigned',
        icon: 'fas fa-clipboard-list',
        label: t('settings.notify_assigned')
      });
    }
    items.add('docketOutcome', {
      name: 'docketOutcome',
      icon: 'fas fa-flag-checkered',
      label: t('settings.notify_outcome')
    });
    items.add('docketCrowd', {
      name: 'docketCrowd',
      icon: 'fas fa-users-slash',
      label: t('settings.notify_crowd')
    });
  });
});